import { c as _c } from "react/compiler-runtime";
import type { NextGenCollection } from "@/entities/INextgen";
import { NextgenView } from "@/types/enums";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import { Status } from "../nextgen_entities";
import { formatNameForUrl, getStatusFromDates } from "../nextgen_helpers";
import NextGenCollectionArtist from "./collectionParts/NextGenCollectionArtist";
import { NextGenCountdown, NextGenMintCounts, NextGenPhases } from "./collectionParts/NextGenCollectionHeader";
import NextGenCollectionSlideshow from "./collectionParts/NextGenCollectionSlideshow";
import styles from "./NextGen.module.scss";
interface Props {
  collection: NextGenCollection;
  setView: (view: NextgenView) => void;
}
export default function NextGen(props) {
  const $ = _c(57);
  const available = props.collection.total_supply - props.collection.mint_count;
  const t0 = `url(${props.collection.banner})`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className={styles.nextgenBanner} style={{
      background: t0
    }} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== available || $[3] !== props.collection) {
    t2 = <Row><Col><NextGenPhases collection={props.collection} available={available} /></Col></Row>;
    $[2] = available;
    $[3] = props.collection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.collection.name) {
    t3 = formatNameForUrl(props.collection.name);
    $[5] = props.collection.name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `/nextgen/collection/${t3}`;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      fontSize: "60px"
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props.collection.name || $[9] !== t4) {
    t6 = <Row className="pt-2"><Col><Link href={t4} className="decoration-none font-bolder" style={t5}>{props.collection.name}</Link></Col></Row>;
    $[8] = props.collection.name;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      fontSize: "48px",
      lineHeight: "48px"
    };
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = `/${props.collection.artist_address}`;
  let t9;
  if ($[12] !== props.collection.artist || $[13] !== t8) {
    t9 = <Row className="font-larger font-color font-bolder"><Col className="font-larger font-lighter" style={t7}>by{" "}<Link href={t8} className="decoration-hover-underline">{props.collection.artist}</Link></Col></Row>;
    $[12] = props.collection.artist;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== props.collection) {
    t10 = <Row className="pt-3 font-larger font-color"><Col><NextGenMintCounts collection={props.collection} /></Col></Row>;
    $[15] = props.collection;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== props.collection.name) {
    t11 = formatNameForUrl(props.collection.name);
    $[17] = props.collection.name;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = `/nextgen/collection/${t11}`;
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <button className={`font-larger pt-2 pb-2 no-wrap ${styles.exploreBtn}`}><span className="font-larger">Explore Collection</span></button>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t12) {
    t14 = <Row className="pt-3"><Col><Link href={t12}>{t13}</Link></Col></Row>;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== props.collection) {
    t15 = <Row className="pt-4 pb-2"><Col><NextGenCountdown collection={props.collection} /></Col></Row>;
    $[22] = props.collection;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t10 || $[25] !== t14 || $[26] !== t15 || $[27] !== t2 || $[28] !== t6 || $[29] !== t9) {
    t16 = <Container className="tw-z-10"><Row><Col><Container className="pt-5 pb-5 no-padding"><Row><Col sm={12} md={6}>{t2}{t6}{t9}{t10}{t14}{t15}</Col></Row></Container></Col></Row></Container>;
    $[24] = t10;
    $[25] = t14;
    $[26] = t15;
    $[27] = t2;
    $[28] = t6;
    $[29] = t9;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t1 || $[32] !== t16) {
    t17 = <div className={styles.nextgenBannerWrapper}>{t1}{t16}</div>;
    $[31] = t1;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      backgroundColor: "black"
    };
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <b>NextGen</b>;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <br />;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== props) {
    t21 = () => {
      props.setView(NextgenView.ABOUT);
      window.scrollTo(0, 120);
    };
    $[37] = props;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="font-larger">Learn More</span>;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t21) {
    t23 = <Container fluid={true} className="pt-5 pb-5" style={t18}><Row><Col><Container className="pt-3 pb-3"><Row><Col className="font-larger text-center">{t19} is an on-chain generative art NFT contract. It is also a tool to support the ambitious aspirations of the 6529 community in the areas of art experimentation and decentralized social organization.{t20}<button className="btn-link pt-2" onClick={t21}>{t22}</button></Col></Row></Container></Col></Row></Container>;
    $[40] = t21;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== props.collection.name) {
    t24 = <Row><Col><h1>Explore {props.collection.name}</h1></Col></Row>;
    $[42] = props.collection.name;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] !== props.collection) {
    t25 = <Row className="pt-3"><Col><NextGenCollectionSlideshow collection={props.collection} /></Col></Row>;
    $[44] = props.collection;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t24 || $[47] !== t25) {
    t26 = <Container className="pt-5">{t24}{t25}</Container>;
    $[46] = t24;
    $[47] = t25;
    $[48] = t26;
  } else {
    t26 = $[48];
  }
  let t27;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Row><Col><h1>Featured Artist</h1></Col></Row>;
    $[49] = t27;
  } else {
    t27 = $[49];
  }
  let t28;
  if ($[50] !== props.collection) {
    t28 = <Container className="pt-5 pb-5">{t27}<Row><Col><NextGenCollectionArtist collection={props.collection} /></Col></Row></Container>;
    $[50] = props.collection;
    $[51] = t28;
  } else {
    t28 = $[51];
  }
  let t29;
  if ($[52] !== t17 || $[53] !== t23 || $[54] !== t26 || $[55] !== t28) {
    t29 = <>{t17}{t23}{t26}{t28}</>;
    $[52] = t17;
    $[53] = t23;
    $[54] = t26;
    $[55] = t28;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  return t29;
}
export function DistributionLink(props) {
  const $ = _c(8);
  const alStatus = getStatusFromDates(props.collection.allowlist_start, props.collection.allowlist_end);
  const publicStatus = getStatusFromDates(props.collection.public_start, props.collection.public_end);
  if (alStatus === Status.UPCOMING || alStatus === Status.LIVE || publicStatus !== Status.COMPLETE) {
    const t0 = `pt-1 font-color ${props.class ? props.class : ""}`;
    let t1;
    if ($[0] !== props.collection.name) {
      t1 = formatNameForUrl(props.collection.name);
      $[0] = props.collection.name;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    const t2 = `/nextgen/collection/${t1}/distribution-plan`;
    let t3;
    if ($[2] !== t2) {
      t3 = <Col><Link href={t2}>Distribution Plan</Link></Col>;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== t0 || $[5] !== t3) {
      t4 = <Container className="no-padding"><Row className={t0}>{t3}</Row></Container>;
      $[4] = t0;
      $[5] = t3;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t0;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
}